import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-darse-alta',
  templateUrl: './darse-alta.component.html',
  styleUrls: ['./darse-alta.component.css']
})
export class DarseAltaComponent implements OnInit {
  nombreEmpresa:any;
  direccion:any
  telefono:any
  email:any
  password:any;
  password1:any;

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  save(){
    if (!this.validation(this.nombreEmpresa)) {
      notify('Debe ingresar datos en el campo EMPRESA', 'warning', 4000);
      return 
    } else if (!this.validation(this.direccion)) {
      notify('Debe ingresar datos en el campo DIRECCION', 'warning', 4000);
      return 
    }else if (!this.validation(this.telefono)) {
    notify('Debe ingresar datos en el campo TELEFONO', 'warning', 4000);
    return 
    } else if (!this.validation(this.email)) {
      notify('Debe ingresar datos en el campo EMAIL', 'warning', 4000);
      return 
    } else if (!this.validarEmail(this.email)) {
      notify('El email ingresado es invalido', 'warning', 4000);
      return 
    } else if (!this.validation(this.password)) {
      notify('Debe ingresar datos en el campo CONTRASEÑA', 'warning', 4000);
      return 
    } else if (!this.validation(this.password1)) {
      notify('Debe ingresar confirmar la contraseña', 'warning', 4000);
      return 
    } else if (this.password != this.password1) {
      notify('Confirme nuevamente la contraseña', 'warning', 4000);
      this.password1='';
      return 
    } else{
      notify('Registro de forma exitosa', 'success', 4000);
      const data={
        empresa:this.nombreEmpresa,
        direccion: this.direccion,
        telefono: this.telefono,
        correo:this.email,
        contraseña:this.password
      }
      console.log(data)
      this.router.navigate(["login"])
      // Enviar correo de bienvenida
    }
    
  }

  validation(val:any) {
    if (val == null || val == undefined || val == '') {
      return false;
    }else{
      return true;
    }
  }
  
  validarEmail(valor:any) {
    if (/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(valor)){
        return true;
    } else {
        return false;
    }
  }

  resolved(e:any){
    console.log(e)
  }

}
